// Imprint (Impressum) — provider identification under § 5 DDG and § 18 MStV. The operator is in
// founding stage and publishes no email address (owner's decision, 2026-11-03): contact goes
// through the official accounts, to be announced.
import { CONTACT, LegalLayout, LegalLink, OperatorAddress } from "./LegalLayout";

export function Imprint() {
  return (
    <LegalLayout slug="imprint" title="Imprint" subtitle={<span lang="de">Impressum</span>}>
      <p>
        Information about the provider of The Infinite, as required by § 5 of the German Digital Services Act (
        <span lang="de">Digitale-Dienste-Gesetz, DDG</span>) and § 18 of the German Interstate Media Treaty (
        <span lang="de">Medienstaatsvertrag, MStV</span>).
      </p>

      <h2>Service provider</h2>
      <p>
        <span lang="de">Angaben gemäß § 5 DDG</span>
      </p>
      <OperatorAddress />

      <h2>Contact</h2>
      <p>Please {CONTACT}. We answer in English and German.</p>

      <h2>Responsible for editorial content</h2>
      <p>
        <span lang="de">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</span>:
      </p>
      <OperatorAddress />
      <p className="muted">
        Songs, song titles and nicknames are contributed by users and are not editorial content of the operator.
      </p>

      <h2>Hosting</h2>
      <p>
        This website runs on a server in Germany operated by IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Germany.
      </p>

      <h2>Reporting illegal content; points of contact</h2>
      <p>
        Every song has a <em>Report</em> button, on its card in the River and on its song page; reports go straight to
        the administrators. For anything else, including content you believe infringes your rights (for example a copied
        melody), {CONTACT}: please include the song's address (its page under <code>/loop/…</code>), what is wrong, and
        why. This is also our single point of contact for authorities and for users under Articles 11 and 12 of the EU
        Digital Services Act; you can write to us in English or German.
      </p>

      <h2>Consumer dispute resolution</h2>
      <p>
        We are not obliged and not willing to take part in dispute resolution proceedings before a consumer arbitration
        board (§ 36 <span lang="de">Verbraucherstreitbeilegungsgesetz, VSBG</span>).
      </p>

      <h2>Liability for content</h2>
      <p>
        We keep our own content on these pages accurate and up to date as best we can, but we cannot guarantee it. Most
        of what plays on The Infinite is written by contributors. As a hosting provider we are not obliged to monitor
        that third-party content or to look for circumstances that point to illegal activity. Obligations to remove or
        block content under general law remain unaffected; liability in that respect is only possible from the moment we
        become aware of a specific infringement. When we learn of such an infringement, we remove or hide the content
        without delay.
      </p>

      <h2>Liability for links</h2>
      <p>
        Our pages contain a few links to external websites (for example the Creative Commons licence text). We have no
        influence over their content and accept no responsibility for it; the respective provider is always responsible.
        We checked the linked pages when we linked them. If we become aware of legal violations, we remove such links
        without delay.
      </p>

      <h2>Copyright</h2>
      <p>
        Songs are written by their contributors and licensed under Creative Commons Attribution 4.0 (CC BY 4.0); see the{" "}
        <LegalLink to="licence">Licence</LegalLink> page for how to credit them. The Infinite's software, design and
        name: © 2026 The Infinite Beat Project. All rights reserved.
      </p>
    </LegalLayout>
  );
}
